import { ButtonColor } from "@/common/enum/button-color";
import { AdminHomeSalesChart } from "@/components/chart/AdminHomeSalesChart";
import { AngleRightOutlineIcon } from "@/components/icon/AngleRightlineIcon";
import { AdminHomeHistoryPanel } from "@/components/panel/AdminHomeHistoryPanel";
import { AdminOrderStatusPanel } from "@/components/panel/AdminOrderStatusPanel";
import { AdminHomeItemTable } from "@/components/table/admin-home-item-table/AdminHomeItemTable";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { H4 } from "@/components/typography/H4";
import { H5 } from "@/components/typography/H5";
import { PageWrapper } from "@/components/wrapper/PageWrapper";
import { Button } from "flowbite-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AdminItemPath } from "../common/enum/path";
import { formatCommasNumber } from "../common/util/format-number-with-commas";
import { userService } from "../services/user-service";
import { AdminHomeSalesDto } from "../types/dto/admin-home-sales-dto";

export const AdminHomePage = () => {
  const navigate = useNavigate();

  const [sales, setSales] = useState<AdminHomeSalesDto[]>([]);

  const getSales = async () => {
    const response = await userService.getAdminHomeSales();
    console.log(response);
    setSales(response.data);
  };

  useEffect(() => {
    getSales();
  }, []);

  const last = sales[sales.length - 1];

  return (
    <PageWrapper>
      <div className="flex flex-col w-[1392px] gap-[24px]">
        <AdminOrderStatusPanel />
        <div className="flex gap-[24px]">
          <div className="w-[580px]">
            <div className="w-[580px] h-[60px] py-[16px]">
              <H4>매출 월 별 현황</H4>
            </div>
            <div className="flex flex-col bg-white h-[496px] border rounded-[8px] gap-[24px] py-[32px] px-[24px] box-border items-center">
              {sales.length > 0 && (
                <>
                  <AdminHomeSalesChart data={sales} />
                  <div className="flex">
                    <div className="flex border-t w-[532px] pt-[24px]">
                      <div className="flex flex-col gap-[8px] justify-between items-center w-[177.33px]">
                        <H5 className="text-semantic-text-body">{`${last.numInvoice}건`}</H5>
                        <Body14Regular className="text-semantic-text-secondary">
                          {`${last.month}월 발주 건 수`}
                        </Body14Regular>
                      </div>
                      <div className="flex flex-col gap-[8px] justify-between items-center w-[177.33px] border-l">
                        <H5 className="text-semantic-text-body">{`${last.numPartnerInMonth}명`}</H5>
                        <Body14Regular className="text-semantic-text-secondary">
                          {`${last.month}월 신규 가입`}
                        </Body14Regular>
                      </div>
                      <div className="flex flex-col gap-[8px] justify-between items-center w-[177.33px] border-l">
                        <H5 className="text-semantic-text-body">{`${formatCommasNumber(
                          last.totalSales
                        )}원`}</H5>
                        <Body14Regular className="text-semantic-text-secondary">
                          {`${last.month}월 총 매출액`}
                        </Body14Regular>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="flex flex-col w-[788px]">
            <div className="w-full py-[16px] h-[60px]">
              <div className="flex h-[38px] justify-between items-center">
                <H4>상품 현황</H4>
                <Button
                  color={ButtonColor.TRANSPARENT_OUTLINE}
                  size={"sm"}
                  onClick={() => {
                    navigate(AdminItemPath.SINGLE_PRODUCT);
                  }}
                >
                  <div className="flex items-center gap-[8px]">
                    <Body14Regular>전체 상품 리스트 보기</Body14Regular>
                    <AngleRightOutlineIcon size={16} />
                  </div>
                </Button>
              </div>
            </div>
            <AdminHomeItemTable />
            <AdminHomeHistoryPanel />
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};
